import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SelectPopoverScrollEndConstantType,
    SelectPopoverDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const SELECT_POPOVER_SCROLL_END_THRESHOLD = 0.85;

export const getSelectPopoverIsScrollEnd = ({
    contentHeight,
    layoutHeight,
    threshold,
    offset
}: SelectPopoverScrollEndConstantType): boolean => {
    const maxScroll = contentHeight - layoutHeight;

    if(maxScroll <= 0) {
        return false;
    }

    return offset / maxScroll >= threshold;
};

const stylesheet = StyleSheet.create({
    footer: {
        flexDirection: "row",
        alignItems: "center"
    },
    count: {
        minWidth: 0,
        flex: 1
    }
});

export const useStyles = ({
    spaces
}: SelectPopoverDynamicStyleType) => {
    const styles = {
        footer: {
            paddingStart: spaces.spacingSm,
            paddingEnd: spaces.spacingXs,
            paddingTop: spaces.spacingXs,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
